"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TBCommunityCTA = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@storyblok/react");
var helpers_1 = require("../../helpers");
function TBCommunityCTA(_a) {
    var blok = _a.blok;
    var listContainer = [];
    Object.keys(blok).forEach(function (bk) {
        if (bk.includes("list") && blok[bk].length > 0) {
            listContainer.push(blok[bk]);
        }
    });
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, (0, react_1.storyblokEditable)(blok), { className: "bg-topia-black p-4 py-8 md:py-12", children: (0, jsx_runtime_1.jsxs)("div", { className: " mx-auto flex w-full max-w-5xl flex-col-reverse gap-8 md:flex-row md:items-center md:gap-10", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "topia-sb-rich-text text-4xl text-white", dangerouslySetInnerHTML: {
                                __html: (0, helpers_1.topiaRichText)(blok.title),
                            } }), (0, jsx_runtime_1.jsx)("div", { className: "topia-sb-rich-text text-white ", dangerouslySetInnerHTML: {
                                __html: (0, helpers_1.topiaRichText)(blok.description),
                            } }), (0, jsx_runtime_1.jsx)("ul", { className: "flex flex-col pl-8", children: listContainer.map(function (listItem, ix) { return ((0, jsx_runtime_1.jsx)("li", { className: "mb-2 list-disc text-xl text-white", children: listItem }, ix)); }) }), (0, jsx_runtime_1.jsx)("a", { href: blok.link, className: "hover:border- w-fit rounded-full bg-future-blue p-6 px-16 text-xl  font-bold text-white text-topia-black transition ease-linear", children: blok.button_text })] }), (0, jsx_runtime_1.jsx)("a", { href: blok.link, className: " flex-shrink-0 self-center ", children: (0, jsx_runtime_1.jsx)("img", { src: blok.image.filename, alt: blok.image.alt, className: " w-[200px] md:w-[280px] " }) })] }) })));
}
exports.TBCommunityCTA = TBCommunityCTA;
